import { ViewCell, ViewConfig } from "@lib/views";
import { EmailCell } from "../cells/EmailCell";
import { LimitCell } from "../cells/LimitCell";
import { ReceiptSenderActionsCell } from "../cells/ReceiptSenderActionsCell";

export enum ReceiptSenderColumn {
    EMAIL = "email",
    LIMIT = "limit",
    ACTIONS = "actions",
}

export interface ReceiptSenderRow {
    id: string;
    email: string | null;
    limit: number;
    workspaceId: string;
    createdAt: Date;
    updatedAt: Date;
}

export const receiptSendersViewConfig: ViewConfig<
    ReceiptSenderRow,
    ReceiptSenderColumn,
    never
> = {
    columns: {
        [ReceiptSenderColumn.EMAIL]: {
            accessorKey: "email",
            name: "Email",
            header: "Email",
            cell: EmailCell,
            minSize: 200,
            maxSize: 1000,
        },
        [ReceiptSenderColumn.LIMIT]: {
            accessorKey: "limit",
            name: "Limit",
            header: "Limit",
            cell: LimitCell,
            minSize: 100,
            maxSize: 150,
        },
        [ReceiptSenderColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            cell: ReceiptSenderActionsCell as unknown as ViewCell<
                ReceiptSenderRow,
                string
            >,
            minSize: 60,
            maxSize: 60,
            immutable: true,
            hiddenFromSettings: true,
        },
    },
};
